module.exports = __webpack_public_path__ + "static/media/iconSend.127d3c44.svg";